import React, { useState } from "react";
import { Edit3, Bell, Ban, Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import { formatNumber } from "../../../utils/formatNumber";
import { Customer } from "../../../types/modules/admin/customer.type";
import { PermissionGate } from "../PermissionGate";
import { PermissionsKey } from "../../../data/permissions";
import CustomModal from "../../ui/CustomModal";
import UpdateCustomerBasicInfo from "./UpdateCustomerBasicInfo";
import { CustomerStatus } from "../../../types/enum/customerStatus";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import OverLayLoading from "../../ui/OverLayLoading";

export default function CustomerHeader({ customer }: { customer: Customer }) {
  const { t } = useTranslation();
  const [openModel, setOpenModel] = useState(false);


    const {updateResource, loading} = useUpdateResource();
     async function handleStatus () {
      await updateResource(`customer/toggle-status/${customer.id}`, {}, "admin", {
        method: "PUT",
        successMessage: t("update_success"),
        confirmMessage:t('general_confirm_message'),
        invalidateQueries: ["customer-detalis-by-admin","customers-by-admin"],
      });
    };

  return (
    <div className="bg-white shadow-custom-light rounded-2xl p-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div className="flex items-center gap-4">
        {customer.avatar ? (
          <img
            src={customer.avatar.url}
            alt={customer.id.toString()}
            className="w-16 h-16 rounded-full object-cover border-2 border-primary"
          />
        ) : (
          <div className="w-16 h-16 rounded-full bg-LightGrey1 flex items-center justify-center text-muted font-medium">
            {customer.name?.charAt(0).toUpperCase()}
          </div>
        )}

        <div>
          <h2 className="text-xl font-semibold">{customer.name}</h2>
          <p className="text-muted text-sm">
            {t("customer_detail.status")}:{" "}
            <span
              className={`font-medium ${
                customer.status === "active" ? "text-success" : "text-danger"
              }`}
            >
              {customer.status === "active"
                ? t("customer_detail.active")
                : t("customer_detail.blocked")}
            </span>
          </p>
          <p className="text-sm text-muted">
            {t("customer_detail.id")}: {formatNumber(customer.id)}
          </p>
        </div>
      </div>

      <PermissionGate permissions={[PermissionsKey.UpdateCustomer]}>
        <div className="flex gap-2">
        {
          customer.status===CustomerStatus.ACTIVE ?
            <button 
            onClick={handleStatus}
            className="bg-danger text-white px-4 py-2 rounded-xl flex items-center gap-2 hover:opacity-90 transition">
            <Ban size={18} /> {t("suspend")}
          </button>
          :
          <button 
          onClick={handleStatus}
          className=" bg-success text-white px-4 py-2 rounded-xl flex items-center gap-2 hover:opacity-90 transition">
            <Check size={18} /> {t("reactivate")}
          </button>
        }
        <button className="bg-accent text-Black px-4 py-2 rounded-xl flex items-center gap-2 hover:opacity-90 transition">
          <Bell size={18} /> {t("actions_btn.notify")}
        </button>
        <button 
        onClick={()=>setOpenModel(true)}
        className="bg-primary text-white px-4 py-2 rounded-xl flex items-center gap-2 hover:opacity-90 transition">
          <Edit3 size={18} /> {t("actions_btn.edit")}
        </button>
      </div>
      </PermissionGate>
       <CustomModal
        isOpen={openModel}
        onClose={() => setOpenModel(false)}
        title={t('update_information')}
        >
          <UpdateCustomerBasicInfo 
          defaultValues={{avatarId:customer.avatar?customer.avatar.id:null, name:customer.name??"",email:customer.email??""}}
          id={customer.id}
          onSubmitSuccess={()=>setOpenModel(false)}
          />
        </CustomModal>
        {
          loading && <OverLayLoading/>
        }
    </div>
  );
}
